import React from 'react';
import './Syles/Features.scss';
import StyledTitle from '../../Shared/StyledTitle/StyledTitle';
import { features } from './data';
const Features=()=>{
    return(
        <div className="home-features">
            <StyledTitle 
            title="HostDesign features"
            desc="You can use Hostdesign unlimited for free, and if you want you can support us with coffee and help us make Hoststyle even better product."
            />
            <ul>
                {features.map((item) =>{
                    return(
                        <li>
                            <div className="circle">
                                {item.icon}
                            </div>
                            <h2>{item.title}</h2>
                            <p>{item.desc}</p>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
};
export default Features ;